module.exports = __webpack_public_path__ + "static/img/bg-es.74923f9e.png";